import { render, staticRenderFns } from "./MessageTableHeader.vue?vue&type=template&id=ed860edc&"
import script from "./MessageTableHeader.vue?vue&type=script&lang=js&"
export * from "./MessageTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./MessageTableHeader.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports